export default __webpack_public_path__ + "static/media/student_practice_assigned.5df1d767.svg";